import { FolderForestTreeType } from 'owa-favorites-types';
import { SHARED_FOLDERS_TREE_TYPE } from '../util/folderConstants';
import Folder from '../store/schema/Folder';
import DistinguishedFolderIdName from 'owa-service/lib/contract/DistinguishedFolderIdName';

/**
 * Helper for getting distinguished id folder name for mailbox root
 * @param folder - the root folder of the mailbox
 * @param treeType - tree type of the folder
 */
export default function getDistinguishedFolderIdNameForRootFolder(
    folder: Folder,
    treeType: FolderForestTreeType
): DistinguishedFolderIdName {
    // Shared folder roots have distinguishedIdNames as msgfolderRoot which is same as primary mailbox.
    // We should not populate them to avoid confusion at any point of time
    return treeType === SHARED_FOLDERS_TREE_TYPE
        ? null
        : <DistinguishedFolderIdName>folder.DistinguishedFolderId;
}
